import * as posedetection from "@tensorflow-models/pose-detection";

export class GameBase {
  constructor() {
    this.debugMode = false
    this.stopRecordCallback = null
    this.navigations = []
    this.poseMode = posedetection.SupportedModels.BlazePose
    this.handMode = false
    this.lastSavedtimeSec = new Date().getTime()
  }

  setRect(width, height) {
    this.width = width
    this.height = height
  }

  initPhysics() {

  }

  changeSettings(key, value) {
    // console.log(`${key}: ${this[key]} -> ${value}`)
    this[key] = value
  }

  stopRecord() {
    if(this.stopRecordCallback) {
      this.stopRecordCallback()
      this.stopRecordCallback = null
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/game/GameBase.js